<template>
    <v-form @submit.prevent="onSend" class="flex-grow-1">
        <v-row no-gutters align="center">
            <v-col cols="12" md="10" class="pa-2">
                <v-textarea
                    hide-details
                    v-model="text"
                    auto-grow
                    outlined
                    :rows="3"
                    :disabled="disabled"
                    @click:append="onSend"
                    :placeholder="placeholder"
                    :append-icon="$vuetify.breakpoint.mdAndUp ? '' : 'mdi-send'"
                    @focus="focused = true"
                    @blur="focused = false"
                />
            </v-col>
            <v-col cols="4" md="2" class="pa-md-4 text-right">
                <v-btn :outlined="!text || disabled" block class="sub-button d-none d-md-block" color="cta" @click="onSend">Envoyer</v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>


<script>
    export default {
        name: 'ChatInput',
        props: { disabled: { type: Boolean, default: false } },
        data () { return { text: '', focused: false } },
        computed: {
            placeholder () {
                if(this.focused)
                    return ''
                return '  Décrivez votre projet ou posez une question.'
            }
        },
        methods: {
            onSend () {
                this.$emit('send', this.text)
                this.text = ''
            }
        }
    }
</script>


<style lang="scss">
.v-btn:not(.v-btn--round).v-size--default.sub-button {
    height: 5rem;
}
.v-textarea textarea::placeholder {
  font-size: 1.1em;
  line-height: 3.5;
}
</style>